import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/auth";
import BackToSiteBadge from "@/components/site/BackToSiteBadge";

export default function AffiliateTerms() {
  const [t, setT] = useState(null);
  useEffect(() => { axios.get(`${API}/affiliate/terms`).then((r) => setT(r.data)); }, []);

  return (
    <div className="min-h-screen bg-[var(--cream)] text-[var(--ink)] px-6 md:px-10 py-10">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8">
          <BackToSiteBadge />
        </div>
        <Link to="/affiliate" className="inline-block text-sm text-[var(--muted)] mb-6 hover:text-[var(--marigold)]" data-testid="terms-back">← Back to program</Link>
        <h1 className="font-display text-4xl md:text-5xl mb-4">Program terms</h1>
        <p className="text-xs text-[var(--muted)] mb-10 font-mono-caption tracking-[0.2em] uppercase">
          Version {t?.version || "…"} · Published {t?.published_at ? new Date(t.published_at).toLocaleDateString() : ""}
        </p>
        <article className="prose prose-sm md:prose-base max-w-none" data-testid="terms-body">
          {t?.content_md ? <RenderMd text={t.content_md} /> : <p>Loading…</p>}
        </article>
      </div>
    </div>
  );
}

/** Minimal, safe-ish markdown renderer: headings, bold, lists, paragraphs. */
function RenderMd({ text }) {
  const lines = text.split("\n");
  const out = [];
  let listBuf = null;
  const flushList = () => {
    if (listBuf) {
      out.push(<ul key={`ul-${out.length}`} className="list-disc pl-6 my-3 space-y-1">{listBuf.map((li, i) => <li key={i}>{inline(li)}</li>)}</ul>);
      listBuf = null;
    }
  };
  for (const line of lines) {
    const l = line.trim();
    if (!l) { flushList(); continue; }
    if (l.startsWith("# ")) { flushList(); out.push(<h1 key={out.length} className="font-display text-3xl mt-6 mb-3">{l.slice(2)}</h1>); continue; }
    if (l.startsWith("## ")) { flushList(); out.push(<h2 key={out.length} className="font-display text-2xl mt-6 mb-2">{l.slice(3)}</h2>); continue; }
    if (l.startsWith("### ")) { flushList(); out.push(<h3 key={out.length} className="font-display text-xl mt-4 mb-2">{l.slice(4)}</h3>); continue; }
    if (l.startsWith("- ")) { if (!listBuf) listBuf = []; listBuf.push(l.slice(2)); continue; }
    flushList();
    out.push(<p key={out.length} className="my-3 leading-relaxed">{inline(l)}</p>);
  }
  flushList();
  return <>{out}</>;
}

function inline(s) {
  // bold **x**
  const parts = s.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => p.startsWith("**") && p.endsWith("**") ? <strong key={i}>{p.slice(2, -2)}</strong> : <span key={i}>{p}</span>);
}
